
import loadjs from 'loadjs';

export default async function loadScripts(scripts) {
    return new Promise((resolve, reject) => {
        loadjs(scripts, () => {
            resolve();
        });
    });
}
